export default {"src":"/_next/static/media/SPLK.2fbac7c4.svg","height":18,"width":18};